import React from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { isFrontPage } from 'helpers/url-manager';
import { PageProps } from 'interfaces/page-props';
import { useSeo } from 'hooks/use-seo';
import { BASE_URL } from 'helpers/global.const.helper';
import { ORGANIZATION_STRUCTURED_DATA } from 'helpers/structured-data';

const StructuredData: React.FC = () => {
    const seo = useSeo();
    const pageUrl = useSelector((state: PageProps) => state.pageUrl);

    const getImageURL = (image: string): string => {
        return image.startsWith('https://') ? image : `${BASE_URL}${image}`;
    };

    const webSiteStructuredData = {
        '@context': 'http://schema.org/',
        '@type': 'WebSite',
        '@id': 'https://www.skapiec.pl/#/schema/WebSite/1',
        'name': 'Skąpiec.pl',
        'url': 'https://www.skapiec.pl/',
        'potentialAction': {
            '@type': 'SearchAction',
            'target': {
                '@type': 'EntryPoint',
                'urlTemplate': 'https://www.skapiec.pl/szukaj?query={search_term_string}'
            },
            'query-input': 'required name=search_term_string'
        }
    };

    const webPageStructuredData = {
        '@type': 'WebPage',
        '@id': seo.canonical,
        'url': seo.canonical,
        'name': seo.title,
        'description': seo.description,
        'isPartOf': {
            '@id': 'https://www.skapiec.pl/#/schema/WebSite/1'
        },
        'primaryImageOfPage': {
            '@id': getImageURL(seo.og?.image)
        },
        'breadcrumb': {
            '@id': `https://www.skapiec.pl/#/schema/BreadcrumbList${seo.og?.url}`
        }
    };

    const imageObjectStructuredData = {
        '@type': 'ImageObject',
        'id': getImageURL(seo.og?.image),
        'url': getImageURL(seo.og?.image),
        'contentUrl': getImageURL(seo.og?.image),
        'caption': seo.og?.type,
        'width': '856',
        'height': '449'
    };

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(ORGANIZATION_STRUCTURED_DATA) }}
            />
            {isFrontPage(pageUrl) && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteStructuredData) }}
                />
            )}
            {seo.og?.type !== 'ranking' && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageStructuredData) }}
                />
            )}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(imageObjectStructuredData) }}
            />
        </>
    );
};

export default StructuredData;
